import {FULL_WIDTH_CHARACTERS, HALF_WIDTH_CHARACTERS} from "../../constant";
import BaseResourceWriter from "./BaseResourceWriter";

export default class FlutterResourceWriter extends BaseResourceWriter {
    constructor(languageCode,
                trimWhitespace,
                replacePlaceholders,
                replaceFullWidthPlaceholders,
                replaceWhitespaceCharacters,
                retainEmptyValue,
                header) {
        super(languageCode,
            trimWhitespace,
            replacePlaceholders,
            replaceFullWidthPlaceholders,
            replaceWhitespaceCharacters,
            retainEmptyValue,
            header);
        this.resource = {};
    }

    write(key, value) {
        let checkedKey = key.trim();
        if (!checkedKey) return;
        const placeholders = {};
        let checkedValue = value;
        if (this.trimWhitespace) checkedValue = checkedValue.trim();
        if (this.replacePlaceholders) {
            if (this.replaceFullWidthPlaceholders) {
                for (let i = 0; i < FULL_WIDTH_CHARACTERS.length; i++) {
                    checkedValue = checkedValue.replace(new RegExp(FULL_WIDTH_CHARACTERS[i], "g"), HALF_WIDTH_CHARACTERS[i]);
                }
            }
            checkedValue = checkedValue
                .split(/%(?:\d\$)?[sdf@]/g)
                .reduce((previousValue, currentValue, currentIndex) => {
                    const placeholder = `arg${currentIndex - 1}`;
                    placeholders[placeholder] = {};
                    return `${previousValue}{${placeholder}}${currentValue}`;
                });
        }
        if (!checkedValue && !this.retainEmptyValue) return;
        this.resource[key] = checkedValue;
        if (Object.keys(placeholders).length !== 0) {
            this.resource[`@${key}`] = {placeholders};
        }
    }

    addToZip(zip) {
        return zip.file(this.languageCode, JSON.stringify(this.resource, null, 4));
    }
}